import IMProductList from './IMProductList';

export default IMProductList;
